import { mapActions, mapGetters } from "vuex";
import {showErrorSnackBar, showSuccessSnackBar} from "@/utils/SnackBartHelper"
import Utils from '@/scripts/Utils';
import Rules from "@/utils/Rules";

import DiagnosticProposalService from '@/services/firebase/DiagnosticProposal/DiagnosticProposalService';
import DiagnosticService from "@/services/firebase/Diagnostic/DiagnosticService";
import WaterScanApi from "@/services/apiPdf/WaterScanApi";

import NextStepProject from "@/components/Projects/NextStepProject.vue"

import selectResponsibleType from "../Components/select-responsible-type.vue"
import selectProjectPartner from "../Components/select-project-partner.vue"
import selectProjectHunter from "../Components/select-project-hunter.vue"
import selectProjectSeller from "../Components/select-project-seller.vue"
import selectProjectCloser from "../Components/select-project-closer.vue"
import UtilsProjects from "@/pages/Projects/Utils/Utils.js";

import InputMoney from "@/components/Forms/Input/input-money.vue";
import InputFiles from "@/components/Forms/Input/input-files.vue";
import ProjectsService from "@/services/server/ProjectsService";
import SolutionList from "../Diagnostic/Tabs/CheckList/SolutionList.vue";

export default {
    name: "Prospecção",
    components: {
        InputFiles,
        InputMoney,
        NextStepProject,
        selectResponsibleType,
        selectProjectPartner,
        selectProjectHunter,
        selectProjectSeller,
        selectProjectCloser,
    },
    props: {
        openModal: {
            type: Boolean,
            default: false
        },
        idLead: {
            type: String,
            default: null
        },
        idProject: {
            type: String,
            default: null
        },
        idDiagnostic: {
            type: String,
            default: null
        },
        closeFunc: {
            type: Function,
            default: () => { }
        },
        newLead: {
            type: [Object],
            default: () => ({}),
        },
        currentStep: {
            type: String,
            default: null,
          }
    },
    data: () => ({
        loadingTable: true,
        is_loading: false,
        is_created: false,
        is_new_project: false,
        mode: 'draft',
        is_create_lead: false,
        dialog: false,
        itensDialog: {revision:{observation: ''}},
        editedItem: {},
        radioDocument: null,
        radioDocumentOptions: ['CPF', 'CNPJ'],
        project_name: null,
        id_project: null,
        is_completed: false,
        isValidForm: false,
        headers: [
            {
                text: 'Tipo',
                align: 'start',
                sortable: false,
                value: 'type',
            },
            { text: 'Status', value: 'statusFormated' },
            { text: 'Obs', value: 'revision' },
            { text: 'Criada em', value: 'formatedDate' },
            { text: 'Expira em', value: 'expiredDate'},
            { text: '', value: 'actions', align: 'left' },
        ],

        proposalList: [],
        itemsMenuPDF: [
            {
                value: 'proposed',
                title: 'Proposta',
                permission_name: 'waterscan_proposal'
            },
            {
                value: 'checklist',
                title: 'Checklist Simples',
                permission_name: 'waterscan_simple_checklist_report',
            },
            {
                value: 'checklist_with_photo',
                title: 'Checklist Foto',
                permission_name: 'waterscan_photo_checklist_report',
            },
        ],
        idProposalPDF: null,
        dialogDownload: false,
        revision: {},
        revisionDialog: false,
        loadingSaveRevision: false,
        fileLink: null,
        project_data: {},
    }),

    computed: {
        isFranchisee(){
            return this.getCurrentUserRank() === "Franqueado"
        },
        is_draft_mode() {
            return this.mode == 'draft'
        },
        is_save_mode() {
            return this.mode == 'save'
        },
        ruleRequired() {
            return Rules.required()
        },
        ruleString64() {
            return Rules.string(this.mode == 'save', 1, 64)
        },
        ruleCPF() {
            return Rules.cpf(this.mode == 'save')
        },
        ruleCNPJ() {
            return Rules.cnpj(this.mode == 'save')
        },
        ruleEmail() {
            return Rules.email(this.mode == 'save', 64)
        },
        ruleCEP() {
            return Rules.cep(this.mode == 'save')
        },
        ruleIntPositive() {
            return Rules.number(this.mode == 'save')
        },
    },

    methods: {
        ...mapGetters([
            "getCurrentUserRank",
        ]),
        ...mapActions([
            "subscribeChannel",
            "publishChannel",
        ]),
        async addStautsProject(id_project, status, statusAdm = null) {
            await UtilsProjects.addStatusProject(id_project, UtilsProjects.STEPS.APPROVAL, status, this.currentStep)
            await UtilsProjects.addStatusProject(id_project, UtilsProjects.STEPS.APPROVAL, statusAdm ? statusAdm : status, this.currentStep, false)
        },
        truncateText(text, maxLength = 10) {
            if (text && text.length > maxLength) {
              return text.substring(0, maxLength) + '...';
            }
            return text;
        },
        openObservationDialog(item) {
            this.itensDialog = item
          this.dialog = true
        },
        getColor(status) {
            switch (status) {
                case "Aprovada": return "green"
                case "Revisao": return "primary"
                case "Reprovada": return "red"
                case "Desatualizado": return "red"
                default:
                    return "Indefinido!"
            }
        },
        closeProspectingModal() {
            this.closeFunc('approval')
        },
        checkStatus(status) {
            switch (status) {
                case "approved": return "Aprovada"
                case "revision": return "Revisao"
                case "reproved": return "Reprovada"
                case "outdated": return "Desatualizado"
                case "expired": return "Expirado"
                default:
                    return "Indefinido!"
            }
        },
        async formatProposalList() {
            this.loadingTable = true
            const models = [
                { text: "Modelo Performance", value: "model_performance" },
                { text: "Venda do Projeto", value: "payback_sell" },
                { text: "Investimento", value: "investment" },
                { text: "Pré-Fixado", value: "pre_fixed" },
                { text: "Gestão", value: "management" },
            ]
            
            this.proposalList = await DiagnosticProposalService.getWaterScanProposalByDiagnosticId(this.idDiagnostic)
            this.proposalList = this.proposalList.map((proposal) => {
                let expiredDate;
                if(!proposal.expiredAt){
                    expiredDate = new Date (proposal.createdAt.seconds * 1000); 
                    expiredDate.setDate(expiredDate.getDate() + 30);
                    DiagnosticProposalService.editWaterScanProposal(proposal.id_doc,{ ...proposal, expiredAt: expiredDate})
                }else{
                    expiredDate = new Date(proposal.expiredAt.seconds * 1000)
                }
                let now = new Date();
                let status = (expiredDate < now) ? "expired" : proposal.revision?.status
                return {
                    ...proposal,
                    expiredDate: Utils.formatDateDayJs(expiredDate, "DD-MM-YYYY"),
                    formatedDate: Utils.formatDateDayJs(new Date(proposal.createdAt.seconds * 1000), "DD-MM-YYYY [,] HH:mm"),
                    statusFormated: this.checkStatus(status),
                    type: models.find((model) => model.value === proposal.typeProposal.type).text,
                }
            })
            this.loadingTable = false
        },

        async pdfRequest(proposal, action) {
            this.idProposalPDF = proposal.id_doc
            try {
                let response = null
                await DiagnosticService.legacyDiagnosticSolution(proposal.id_diagnostic)
                const solution = await DiagnosticService.getDiagnosticSolutionByDiagnosticId(proposal.id_diagnostic)
                if (!solution) {
                    solution = []
                }
                switch (action) {
                    case 'proposed':
                        response = await WaterScanApi.generateDiagnosticProposalPdf(proposal.id_doc)
                        if (response.status === 200 && typeof response.data.signedUrl) {

                            this.fileLink = response.data.signedUrl
                            this.dialogDownload = true
                            // await WaterScanApi.downloadPdf(response)
                            await UtilsProjects.createInfoLog(this.idProject, UtilsProjects.STEPS.APPROVAL, "Proposta Baixada", this.currentStep)
                        }
                        else showErrorSnackBar("Erro ao gerar proposta. Tente novamente!")

                        break;
                    case 'checklist':
                        response = await WaterScanApi.generateDiagnosticChecklistPdf(proposal.id_doc)
                        if (response.status === 200 && typeof response.data.signedUrl){
                            this.fileLink = response.data.signedUrl
                            this.dialogDownload = true
                            // await WaterScanApi.downloadPdf(response)
                            await UtilsProjects.createInfoLog(this.idProject, UtilsProjects.STEPS.APPROVAL, "Checklist Baixado", this.currentStep)
                        }
                        else showErrorSnackBar("Erro ao gerar proposta. Tente novamente!")
                        break;
                    case 'checklist_with_photo':
                        response = await WaterScanApi.generateChecklisWithPhotoSevenStepsPdf(proposal.id_doc, this.idLead)
                        if (response.status === 200 && typeof response.data.signedUrl) {
                            this.fileLink = response.data.signedUrl
                            this.dialogDownload = true

                            // await WaterScanApi.downloadPdf(response)
                            await UtilsProjects.createInfoLog(this.idProject, UtilsProjects.STEPS.APPROVAL, "Checklist Com Foto Baixado", this.currentStep)
                        }
                        else showErrorSnackBar("Erro ao gerar proposta. Tente novamente!")
                        break;
                }
            } catch (error) {
                console.error(error)
            }
            this.idProposalPDF = ""
        },
        async updateStepToClosing() {
            if (this.getCurrentUserRank() === 'Franqueado') {
                let [status, project] = await ProjectsService.getProjectById(this.$route.params.id)
                const approvedProposals = this.proposalList ?
                    this.proposalList.filter(proposal =>
                        proposal.revision.status === 'approved'
                    ) : [];
                if (approvedProposals.length) {
                    const approvalStep = project.steps.find(({name}) => name === UtilsProjects.STEPS.APPROVAL);

                    if (approvalStep.isCurrentStep) {
                        await UtilsProjects.updateProjectSteps(project.id_doc, UtilsProjects.STEPS.CLOSING, true);
                        this.closeProspectingModal()
                        await this.addStautsProject(this.idProject,402,401)
                        showSuccessSnackBar("Fechamento habilitado!")
                    }
                }
            }
        },
    },
    watch: {},

    async created() {
        await this.formatProposalList();
        await this.updateStepToClosing();
    },
};